import { render, staticRenderFns } from "./AiUserFixedPhraseSelector.vue?vue&type=template&id=721031e2&scoped=true&"
import script from "./AiUserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./AiUserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AiUserFixedPhraseSelector.vue?vue&type=style&index=0&id=721031e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721031e2",
  null
  
)

export default component.exports